module.exports = __webpack_public_path__ + "static/media/Toolbar.595e1471.png";